import React, { useEffect, useMemo, useState } from "react";
import { fetchSocieties } from "./api";
import SearchAutocomplete from "./SearchAutocomplete";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
import './style.css'
import Footer from "../../components/NewFooter/Footer";
import Header from "../../components/NewHeader/Header"

const PropertyVerification = () => {
    const [societies, setSocieties] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sortBy, setSortBy] = useState("all");
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationMeta, setPaginationMeta] = useState(null);

    const [filters,setFilters] = useState([]);
    const logos = [
        { src: "/images/cda-w.svg",  alt: "CDA" },
        { src: "/images/rda-w.svg",  alt: "RDA" },
        { src: "/images/lda-w.svg",  alt: "LDA" },
        { src: "/images/pda-w.svg",  alt: "PDA" },
        { src: "/images/kda-w.svg",  alt: "KDA" },
        { src: "/images/pata-w.svg", alt: "PATA" },
        { src: "/images/gda-w.svg", alt: "GDA" },
        { src: "/images/fda-w.svg", alt: "FDA" },
        { src: "/images/phtp-w.svg", alt: "phpt" },
    ];


    useEffect(() => {
        const loadSocieties = async () => {
            setLoading(true);
            const result = await fetchSocieties(currentPage,'',sortBy);
            setSocieties(result.data || []);
            setFilters(result.societies || [])
            setPaginationMeta(result.meta);
            setLoading(false);
            // Scroll to top when page changes
            window.scrollTo({ top: 0, behavior: 'smooth' });
        };
        loadSocieties();
    }, [currentPage,sortBy]);

    const sortedSocieties = useMemo(() => {
        let sorted = [...societies];

        // if (sortBy === "most-recent") {
        //     sorted = sorted.reverse();
        // } else if (sortBy === "name-asc") {
        //     sorted.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
        // } else if (sortBy === "name-desc") {
        //     sorted.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
        // }
        return sorted;
    }, [societies, sortBy]);

    return (
        <div className="d-flex flex-column min-vh-100">

            <Header/>

            {/* Hero Section */}
            <section className="bg-light py-6 mb-1"
                     style={{
                         // background: "linear-gradient(to bottom, #D4D7E6 0%, #D4D7E6 40%, #FFFFFF 100%)",
                         background: "linear-gradient(to bottom, #D4D7E6 0%, #D4D7E6 70%, #FFFFFF 100%)",
                         padding: "10px 0",
                     }}>
                <div className="container"
                >
                    <div className="text-center">

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "26px",
                            }}
                        >
                            {logos.map((logo) => (
                                <img key={logo.src} src={logo.src} alt={logo.alt} />
                            ))}
                        </div>
                        <p className="heading-1 text-center mt-4 mb-4">Property Verification</p>
                        {/*<p*/}
                        {/*    className="lead  mx-auto text-center"*/}
                        {/*    style={{*/}
                        {/*        maxWidth: 720,*/}
                        {/*        lineHeight: 1.6,*/}
                        {/*        color: '#525252',*/}
                        {/*        fontSize: "16px",*/}
                        {/*        margin: '20px 0px'*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    Streamline your property verification process with our comprehensive*/}
                        {/*    documentation and compliance management system.*/}
                        {/*</p>*/}
                    </div>
                    {/*<div className="row justify-content-center">
                        <div className="col-md-6">
                            <SearchAutocomplete
                                placeholder="Search..."
                                onSelect={(society) => {
                                    // Handle selection if needed
                                    // console.log("Selected society:", society);
                                }}
                            />
                            <select style={{
                                height: '35px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '0 8px',
                                fontSize: '14px',
                                background: '#fff',
                                color:' #333'
                            }}>
                                <option value="">All</option>
                                <option value="name">Name</option>
                                <option value="email">Email</option>
                                <option value="phone">Phone</option>
                            </select>
                        </div>
                    </div>*/}
                    <div className="row justify-content-center">
                        <div className="col-md-6">

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    width: "100%",
                                    height: "55px",
                                    padding: "5px 10px",
                                    borderRadius: "9999px",
                                    background: "#fff",
                                    border: "1px solid rgb(230, 231, 235)",
                                    boxShadow: "rgba(0, 0, 0, 0.08) 0px 8px 18px",
                                }}
                            >
                                {/* Search Component */}
                                <SearchAutocomplete
                                    containerStyle={{flex: 1}}
                                    filterAuthority={sortBy}
                                    inputStyle={{
                                        width: "100%",
                                        height: "100%",
                                        border: "none",
                                        outline: "none",
                                        fontSize: "14px",
                                        background: "transparent",
                                    }}
                                    placeholder="Search..."
                                />

                                {/* Dropdown INSIDE the bar */}
                                <select
                                    value={sortBy}
                                    onChange={(e) => {
                                        setSortBy(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                    style={{
                                        height: "35px",
                                        border: "0px solid #ddd",
                                        borderRadius: "8px",
                                        padding: "0",
                                        fontSize: "14px",
                                        background: "#fff",
                                        color: "#333",
                                        resize:'none',
                                        outline: 'none',
                                        boxShadow: 'none',
                                        transition: "border 0.2s ease",
                                    }}
                                >
                                    <option value="all">All Authorities</option>
                                    {
                                        filters.map((society)=>{
                                            return (
                                                <option value={society}>{society}</option>
                                            )
                                        })
                                    }

                                  {/*  <option value="RDA">RDA</option>
                                    <option value="LDA">LDA</option>
                                    <option value="KDA">KDA</option>
                                    <option value="PDA">PDA</option>
                                    <option value="PHATA">PHATA</option>
                                    <option value="GDA">GDA</option>
                                    <option value="FDA">FDA</option>*/}
                                </select>
                            </div>

                        </div>
                    </div>

                </div>
            </section>

            {/* Main Content */}
            <main className="container flex-grow-1 py-2">
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div>
                                <p className="heading-2 mb-0">
                                    List of Housing Schemes{" "}
                                    <span className="text-muted fs-6 fw-normal align-middle">
                                         ({paginationMeta?.total || sortedSocieties.length} Housing Schemes )
                                    </span>
                                </p>
                            </div>
                            <div className="d-flex align-items-center" style={{display:'none'}}>
                                {/*<label className="me-2 text-dark">Authority:</label>
                                <select
                                    className="form-select form-select-sm"
                                    style={{width: "auto"}}
                                    value={sortBy}
                                    onChange={(e) => {
                                        setSortBy(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                >
                                    <option value="all">All</option>
                                    <option value="CDA">CDA</option>
                                    <option value="RDA">RDA</option>
                                </select>*/}
                            </div>
                        </div>

                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="d-flex flex-column gap-2">
                                {sortedSocieties.map((society) => (
                                    <div
                                        key={society.id}
                                        className="bg-light rounded-3 p-3"
                                        style={{ cursor: "pointer" }}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => {
                                            if (society.pdf_url) {
                                                window.open(
                                                    society.pdf_url,
                                                    "_blank",
                                                    "noopener,noreferrer"
                                                );
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" && society.pdf_url) {
                                                window.open(
                                                    society.pdf_url,
                                                    "_blank",
                                                    "noopener,noreferrer"
                                                );
                                            }
                                        }}
                                    >
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h5 className="mb-0 text-dark">{society.name}</h5>
                                            {society.pdfUrl && (
                                                <i className="bi bi-file-pdf text-danger" />
                                            )}
                                            <div>{society.name_authority}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Pagination */}
                        {!loading && paginationMeta && paginationMeta.lastPage > 1 && (() => {
                            const pages = [];
                            const totalPages = paginationMeta.lastPage;

                            // Always show first page
                            pages.push(1);

                            // Calculate range around current page
                            let start = Math.max(2, currentPage - 1);
                            let end = Math.min(totalPages - 1, currentPage + 1);

                            // Adjust if we're near the beginning or end
                            if (currentPage <= 3) {
                                start = 2;
                                end = Math.min(4, totalPages - 1);
                            } else if (currentPage >= totalPages - 2) {
                                start = Math.max(2, totalPages - 3);
                                end = totalPages - 1;
                            }

                            // Add ellipsis after first page if needed
                            if (start > 2) {
                                pages.push('ellipsis-start');
                            }

                            // Add pages around current page (avoid duplicates)
                            for (let i = start; i <= end; i++) {
                                if (i !== 1 && i !== totalPages && !pages.includes(i)) {
                                    pages.push(i);
                                }
                            }

                            // Add ellipsis before last page if needed
                            if (end < totalPages - 1) {
                                pages.push('ellipsis-end');
                            }

                            // Always show last page (if more than 1 page and not already added)
                            if (totalPages > 1 && !pages.includes(totalPages)) {
                                pages.push(totalPages);
                            }

                            return (
                                <nav aria-label="Societies pagination" className="mt-4">
                                    <ul className="pagination justify-content-center">
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                                                disabled={currentPage === 1}
                                                aria-label="Previous"
                                            >
                                                <span aria-hidden="true">&laquo;</span>
                                            </button>
                                        </li>
                                        {pages.map((page, idx) => {
                                            if (page === 'ellipsis-start' || page === 'ellipsis-end') {
                                                return (
                                                    <li key={`ellipsis-${idx}`} className="page-item disabled">
                                                        <span className="page-link">...</span>
                                                    </li>
                                                );
                                            }
                                            return (
                                                <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => setCurrentPage(page)}
                                                        style={currentPage === page ? {
                                                            backgroundColor: 'rgb(0, 64, 128)',
                                                            color: 'rgb(255, 255, 255)',
                                                            padding: '8px 16px',
                                                            borderRadius: '4px',
                                                            fontSize: '14px',
                                                            fontWeight: 500,
                                                            lineHeight: 1,
                                                            height: '40px',
                                                            border: 'none',
                                                            cursor: 'pointer'
                                                        } : {}}
                                                    >
                                                        {page}
                                                    </button>
                                                </li>
                                            );
                                        })}
                                        <li className={`page-item ${currentPage === paginationMeta.lastPage ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(prev => Math.min(paginationMeta.lastPage, prev + 1))}
                                                disabled={currentPage === paginationMeta.lastPage}
                                                aria-label="Next"
                                            >
                                                <span aria-hidden="true">&raquo;</span>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            );
                        })()}
                        <p style={{margin:0,marginTop: '37px',fontStyle:'italic',fontSize:'24px',fontWeight:'bold'}}>Disclaimer: All layout plans on this website are sourced from regulatory authorities. For any further information,discrepancies or queries,The concerned regular authorities may be approached.</p>
                    </div>
                </div>
            </main>

            {/* Footer */}
           <Footer/>
        </div>
    );
};

export default PropertyVerification;
